import { store } from '../../../../../../resources/frontend/js/store';
import {enableButton} from '../../../../mixins/quiz/v2.0.0/buttons';
import {setInvalid} from '../../../../mixins/quiz/v2.0.0/invalid';
import {goToQuestion} from '../../../../mixins/quiz/v2.0.0/go-to-question';
import {getNextQuestion} from '../../../../mixins/quiz/v2.0.0/get-next-question';

export const preValidateInvalid = () => {
    const storeLocator = store.state.storeLocator;

    if (storeLocator.runningQuiz) {
        const button = store.state.quiz.zipcode.button;
        const inputContainer = store.state.quiz.zipcode.inputContainer;

        enableButton(button);
        setInvalid(inputContainer);

        storeLocator.runningQuiz = false;
    }
};

export const preValidateValid = () => {
    const storeLocator = store.state.storeLocator;

    if (storeLocator.runningQuiz) {
        const inputContainer = store.state.quiz.zipcode.inputContainer;
        const nextQuestion = getNextQuestion(inputContainer.dataset.questionTo, store.state.quiz.currentQuestion);

        goToQuestion(null, nextQuestion, null);

        storeLocator.runningQuiz = false;
    }
};

export const preValidateNoStores = () => {
    const storeLocator = store.state.storeLocator;

    if (storeLocator.runningQuiz) {
        const button = store.state.quiz.zipcode.button;

        if (store.state.quiz.zipcode.preventCloseDialog) store.commit('dialog/preventClose');
        store.commit('dialog/show', store.state.quiz.zipcode.noBranchDialog);
        enableButton(button);

        storeLocator.runningQuiz = false;
    }
};
